import { Modal } from '@mairistem/composants';
import { isNil } from 'lodash';
import React from 'react';
import type OutilModalProps from '../../../../interfaces/simulation/outilModalProps';
import {
	parseResultatRapport,
	type ResultatRapport,
} from '../../../../utils/simulation/rapportImputationsNonTrouvees';
import RapportImputationsNonTrouvees from '../RapportImputationsNonTrouvees';
import RecopieReportMenu from './RecopieReportMenu';

const RecopieReportModal = ({
	onClose,
	onValidate,
	open,
	simulation,
}: OutilModalProps) => {
	// Renseigne si la reprise des RAR terminee avec succes a ignore des lignes
	// APCP ou repris des RAR sur "Aucun service"
	const [rapport, setRapport] = React.useState<ResultatRapport>();

	const handleClose = () => onClose?.();

	// La reprise des RAR transmet le resultat de son job, la recopie des reports rien
	const handleValidate = (resultat?: unknown) => {
		const resultatRapport = parseResultatRapport(resultat);
		if (
			resultatRapport.imputationsNonTrouvees.length > 0 ||
			resultatRapport.servicesNonHabilites.length > 0
		) {
			setRapport(resultatRapport);
		} else {
			onValidate();
		}
	};

	const handleCloseRapport = () => {
		setRapport(undefined);
		// Les autres lignes ont ete reprises : on rafraichit la simulation
		onValidate();
	};

	return (
		<Modal
			closeIcon
			onClose={rapport ? handleCloseRapport : handleClose}
			open={open}
		>
			<Modal.Header
				content={`Reprendre les résultats reportés et restes à réaliser de ${
					!isNil(simulation?.exercice?.anneeExercice)
						? simulation.exercice.anneeExercice - 1
						: ''
				}`}
			/>
			{rapport ? (
				<RapportImputationsNonTrouvees
					anneeExercice={simulation.exercice.anneeExercice}
					imputations={rapport.imputationsNonTrouvees}
					onClose={handleCloseRapport}
					servicesNonHabilites={rapport.servicesNonHabilites}
					traitement="Reprise des restes à réaliser effectuée."
				/>
			) : (
				<Modal.Content>
					<RecopieReportMenu
						onValidate={handleValidate}
						simulation={simulation}
					/>
				</Modal.Content>
			)}
		</Modal>
	);
};

export default RecopieReportModal;
